<template>
  <div class="navigation-tabs">
    <div class="tabs-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationTabs'
}
</script>

<style lang="sass" scoped>
@import '@/variables.sass'

.navigation-tabs
  background: white
  border-bottom: 1px solid $primary

.tabs-container
  display: flex
  align-items: center
  max-width: 100%
  overflow-x: auto

// Global styles for slotted content (router-links)
::v-deep a
  display: flex
  align-items: center
  padding: 12px 20px
  text-decoration: none
  font-weight: 500
  font-size: 14px
  border-bottom: 3px solid transparent
  transition: all 0.3s ease
  white-space: nowrap
  min-height: 48px
  user-select: none
  position: relative
  color: black !important

  &:hover
    color: $primary
    background-color: rgba(25, 118, 210, 0.04)

  // Only use exact active for proper tab switching
  &.router-link-exact-active
    color: $primary !important
    border-bottom-color: $primary !important
    background-color: rgba(25, 118, 210, 0.04)
    // Use text-shadow instead of font-weight to avoid width change
    text-shadow: 0.3px 0 0 currentColor, -0.3px 0 0 currentColor

  &:first-child
    margin-left: 0

  &:last-child
    margin-right: 0

// Responsive design
@media (max-width: 768px)
  .tabs-container
    flex-wrap: nowrap
    overflow-x: auto
    -webkit-overflow-scrolling: touch

  ::v-deep a
    padding: 10px 16px
    font-size: 13px
    min-width: fit-content

</style>
